class PageNavigation {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.element = element;
    this.initialised = false;
    this.mobileTriggers = this.element.querySelectorAll('.menu-toggle');
    this.searchForm = this.element.querySelector('.search-form');
    this.searchInput = this.element.querySelector('.search-field')
    this.minScrollRequired = 50;

    this.initEvents();
  }

  initEvents() {
    if(this.mobileTriggers){
      this.mobileTriggers.forEach((el) => {
        el.addEventListener("click", this.toggleMobileNav.bind(this));
      });
    }

    (this.element.querySelectorAll(".menu-item-has-children > a:not(.parent-link)") ?? []).forEach(el => {
      el.addEventListener("click", this.toggleSubMenu.bind(this));
    });

    this.searchForm.addEventListener("submit", this.toggleSearchForm.bind(this));

    window.addEventListener('scroll', this.toggleScrollStatus.bind(this), { passive: true });
  }

  toggleScrollStatus() {
    if (this.element.classList.contains("collapsed") || window.innerWidth <= 992) return;

    const navHeight = this.element.offsetHeight - 100;

    if (window.scrollY > navHeight && this.searchInput) {
      this.element.classList.add("collapsed");
      this.searchInput.value = "";
    }
  }

  toggleSearchForm(ev) {
    if (window.innerWidth > 992 && this.searchInput && this.searchInput.value === "") {
      ev.preventDefault();
    }

    this.element.classList.toggle("collapsed");

    if (this.searchInput && !this.element.classList.contains("collapsed")) {
      this.searchInput.focus()
    }
  }

  toggleSubMenu(ev){
    if (window.innerWidth < 992) {
      ev.preventDefault();
    }
    const parentEl = ev.currentTarget.parentElement;
    (this.element.querySelectorAll(".menu-item.open") ?? []).forEach(el => {
      if (el !== parentEl) {
        el.classList.remove("open")
      }
    });


    if (parentEl.classList.contains("open")) {
      parentEl.classList.remove("open");
    } else {
      parentEl.classList.add("open");
    }
  }

  toggleMobileNav(event) {
    event.preventDefault();

    const btn = event.currentTarget;
    const isAlreadyOpen = window.document.documentElement.classList.contains("site-menu-open");

    const text = btn.querySelector('.menu-toggle__text');

    if(text){
      text.innerText = isAlreadyOpen ? "Menu" : "Close";
    }

    window.document.documentElement.classList.toggle("site-menu-open");
  }
}

export default PageNavigation;
